import React, {FC, useEffect, useState, useRef} from 'react';
import { connect, useDispatch } from 'react-redux';
import chatInfoImage from 'assets/svg/chat-info-outline.svg';

import Styles from 'components/chatContent/chatHeader/ChatHeader.module.scss';
import ChatInfoStyles from 'components/chatContent/chatInfo/ChatInfo.module.scss';
import ModalShell from 'components/chatModal/ChatModalShell.module.scss';
import {
  deleteRoom,
  deleteRequest,
  updateParticipantsInRoom,
  beginVideoCall,
} from 'store/services/firebase-broadcast';
import { useHistory } from "react-router";
import deleteIcon from 'assets/svg/delete icon.svg';
import userRequestIcon from 'assets/svg/people-group-outline.svg';
import videoOutlineIcon from 'assets/svg/video-outline.svg';
import joinButtonIcon from 'assets/svg/join button.svg';
import chatHamburgerIcon from 'assets/svg/chat-hamburger.svg';
import closeIconInModal from 'assets/svg/close-icon-in-modal.svg';
import CustomModal from 'components/customModal/CustomModal';
import ProfileAvatar from 'components/profileAvatar/ProfileAvatar';
import { getParticipantsArray } from 'helpers/utils';
import { onValue, ref } from "firebase/database";
import { db } from 'utils/firebase-config';
import Button from 'components/button/Button';
import Toast from 'components/toast/Tost';
import { invitePeopleRequest } from 'store/actions/general.actions';
import { roomDeleteRequest, roomStatusRequest } from 'store/actions/conversation.actions';
import api from 'store/services/conversation.service';
import { useDateTimeFormat } from 'hooks/useDateTimeFormat';
import { flushChatRoomPresence } from 'helpers/chatRoomPresence';

interface ChatHeaderProps {
  cssClass?: string;
  name: string;
  chatInfo?: Function;
  selected: any;
  isJoined: boolean;
  invitePeople: Function;
  onMenuClick?: () => void;
}

const ChatHeader: FC<ChatHeaderProps> = (props: ChatHeaderProps) => {
  const { cssClass, name, chatInfo, selected, isJoined, invitePeople, onMenuClick } = props;
  const [toast, setToast] = useState(false);
  const [toastValues, setToastValues] = useState({message: '', type: ''});
  const [joinRequest, setJoinRequest] = useState(false);
  const [requests, setRequests] = useState([]);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [shouldCheckModalClose, setShouldCheckModalClose] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const { formatDateTime } = useDateTimeFormat();

  const formatJoinRequestTime = (item: any) => {
    const candidate = item?.timestamp ?? item?.createdTime ?? item?.time;
    const formatted = formatDateTime(candidate);
    if (formatted) return formatted;
    return item?.time || '';
  };
  const dispatch = useDispatch();
  const closeDialog = () => {
    document.body.classList.remove('modal-open');
    setJoinRequest(false);
  };

  const closeDeleteConfirm = () => {
    document.body.classList.remove('modal-open');
    setShowDeleteConfirm(false);
  };

  const history = useHistory();

  const showChatInfo = () => {
    if (chatInfo) chatInfo();
  };

  const handleDeleteRoom = () => {
    setShowDeleteConfirm(true);
    document.body.classList.add('modal-open');
  };

  const confirmDeleteRoom = () => {
    const obj = {
        roomId: selected.pk,
    }
    deleteRoom(obj).then(async (e) => {
      dispatch(roomDeleteRequest({
        id: selected.pk,
      }));
      closeDeleteConfirm();
      setTimeout(() => {
        history.push('conversations-nearby');
        window.location.reload();
      }, 500);
    }).catch(() => {
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
      closeDeleteConfirm();
    });
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');



  const handleAccept = async (id: string, requestUser: any) => {
    const participants = getParticipantsArray(selected?.participants);
    const alreadyJoined = participants.some((p) => p?.pk === requestUser?.pk);
    const updatedParticipants = alreadyJoined
      ? participants
      : [...participants, requestUser];

    try {
      await api.acceptJoinRequest({
        room_id: String(selected.pk),
        user_id: String(requestUser.pk),
      });

      await updateParticipantsInRoom({
        roomId: selected.pk,
        user: updatedParticipants,
      });

      const msgPath = `${selected.pk}/requests/${id}`;
      try {
        await deleteRequest(msgPath);
      } catch (err) {
        console.error('Failed to delete request from Firebase:', err);
      }

      setToastValues({
        message: 'Request approved!',
        type: 'Success',
      });
      setToast(true);
      setShouldCheckModalClose(true);
    } catch (error) {
      console.error('Failed to accept join request:', error);
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
    }
  };

  const handleReject = async (id: string, requestUser: any) => {
    const msgPath = `${selected.pk}/requests/${id}`;
    try {
      await api.rejectJoinRequest({
        room_id: String(selected.pk),
        user_id: String(requestUser.pk),
      });

      try {
        await deleteRequest(msgPath);
      } catch (err) {
        console.error('Failed to delete request from Firebase:', err);
      }

      setToastValues({
        message: 'Request rejected!',
        type: 'Success',
      });
      setToast(true);
      setShouldCheckModalClose(true);
    } catch (error) {
      console.error('Failed to reject join request:', error);
      setToastValues({
        message: 'Something went wrong!',
        type: 'Error',
      });
      setToast(true);
    }
  };

  const joinRequests = () => (
    <>
      <div className={`${Styles.joinRequestList} customScrollBarMuted`}>
        {requests.length === 0 ? (
          <p className={Styles.joinRequestEmpty}>No requests found.</p>
        ) : (
          requests.map((item: any, index: number) => (
            <div className={Styles.joinRequestRow} key={index}>
              <ProfileAvatar profile={item.user.profile} alt="user" className={Styles.joinRequestAvatar} />
              <div className={Styles.joinRequestMeta}>
                <span className={`${ChatInfoStyles.roomName} ${Styles.joinRequestName}`}>{item.user.name}</span>
                <span className={Styles.joinRequestMetaSecondary}>{item.user.email}</span>
                <span className={Styles.joinRequestMetaSecondary}>{formatJoinRequestTime(item)}</span>
              </div>
              <div className={Styles.joinRequestActions}>
                <button
                  type="button"
                  className={Styles.joinRequestAcceptBtn}
                  onClick={() => handleAccept(item.id, item.user)}
                >
                  Accept
                </button>
                <button
                  type="button"
                  className={Styles.joinRequestRejectBtn}
                  onClick={() => handleReject(item.id, item.user)}
                >
                  Reject
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      <div className={ModalShell.footer}>
        <button type="button" className={ModalShell.closeBtn} onClick={closeDialog}>
          Close
          <img src={closeIconInModal} alt="" className={ModalShell.closeIcon} />
        </button>
      </div>
    </>
  );

  const deleteConfirmModal = () => (
    <>
      <div className={Styles.deleteRoomBody}>
        <p className={Styles.deleteRoomMessage}>Are you sure you want to delete this room?</p>
      </div>
      <div className={ModalShell.footer}>
        <div className={Styles.deleteRoomFooterActions}>
          <button type="button" className={Styles.deleteRoomCancelBtn} onClick={closeDeleteConfirm}>
            Cancel
          </button>
          <button type="button" className={Styles.deleteRoomDeleteBtn} onClick={confirmDeleteRoom}>
            Delete
          </button>
        </div>
      </div>
    </>
  );



  const activeListenerRef = useRef<(() => void) | null>(null);
  const currentRoomRef = useRef<number | null>(null);

  // Cleanup effect for component unmount
  useEffect(() => {
    return () => {
      if (activeListenerRef.current) {
        activeListenerRef.current();
        activeListenerRef.current = null;
        currentRoomRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (selected?.pk) {
      // Prevent multiple listeners for the same room
      if (currentRoomRef.current === selected.pk && activeListenerRef.current) {
        return;
      }

      // Cleanup previous listener if room changed
      if (activeListenerRef.current) {
        activeListenerRef.current();
        activeListenerRef.current = null;
      }

      const requestsRef = ref(db, `requests/${selected.pk}/requests`);
      currentRoomRef.current = selected.pk;
      
      // Set up the listener
      const unsubscribe = onValue(requestsRef, (querySnapshot: any) => {
        const requests: any = [];
        querySnapshot.forEach((doc: any) => {
          const value = doc.val();
          if (value?.user?.pk != null) {
            requests.push(value);
          }
        });
        setRequests(requests);
      });
      
      // Store the unsubscribe function
      activeListenerRef.current = unsubscribe;
      
      // Cleanup function
      return () => {
        if (activeListenerRef.current === unsubscribe) {
          activeListenerRef.current();
          activeListenerRef.current = null;
          currentRoomRef.current = null;
        }
      };
    } 
  }, [selected?.pk]); // Added selected?.pk dependency to re-run when room changes

  useEffect(() => {
    const interval = setInterval(() => {
      setToast(false);
    }, 6000);

    return () => {
      clearInterval(interval);
    }

  }, []);

  // Effect to handle modal closure when requests are processed
  useEffect(() => {
    if (shouldCheckModalClose && !requests.length) {
      closeDialog();
      setShouldCheckModalClose(false); // Reset the flag
    }
  }, [requests, shouldCheckModalClose]);

  // Effect to auto-open modal when selecting a room with pending requests
  useEffect(() => {
    if (selected?.pk && requests.length > 0 && selected?.host?.pk === user?.pk) {
      setJoinRequest(true);
    }
  }, [selected?.pk, requests.length]);

  const handleJoin = async () => {
    setIsVideoLoading(true);
    try {
      const isHost = selected?.host?.pk === user?.pk;
      const isStartingNewVideo = isHost && selected.status !== 'VIDEO';

      if (isStartingNewVideo) {
        // Only mark the room live / navigate here. The participant notification
        // email is sent when the host actually joins the meeting (Jitsi.tsx
        // videoConferenceJoined) — not on this video-icon click.
        await api.roomStatusRequest({ id: selected.pk, status: 'VIDEO' });
        await beginVideoCall(selected.pk);
      }

      if (!isHost) {
        if (!selected?.call_active) {
          setToastValues({
            message: 'The host has not started the video call yet.',
            type: 'Error',
          });
          setToast(true);
          return;
        }
      }

      const canJoinCall = isHost
        ? isJoined || isStartingNewVideo
        : isJoined && selected.status === 'VIDEO' && selected.call_active;

      if (!canJoinCall) {
        return;
      }

      if (selected?.host?.is_super_host) {
        if (isJoined || isHost) {
          // Flush chat minutes before video starts its own timer.
          flushChatRoomPresence();
          history.push({
            pathname: '/call',
            state: {
              selectedBroadCast: selected,
              isStartingVideo: isStartingNewVideo,
              requireCallActive: !isHost,
            },
          });
        }
      } else if (isJoined || isHost) {
        if (isHost || selected?.participants.length < 3) {
          flushChatRoomPresence();
          history.push({
            pathname: '/call',
            state: {
              selectedBroadCast: selected,
              isStartingVideo: isStartingNewVideo,
              requireCallActive: !isHost,
            },
          });
        }
      }
    } catch (error) {
      console.error('Error in handleJoin:', error);
      setToastValues({
        message: 'Unable to start the video call. Please try again.',
        type: 'Error',
      });
      setToast(true);
    } finally {
      setIsVideoLoading(false);
    }
  }
  return (
    <>
      <div className={`${cssClass} ${Styles.chatHeader}`}>
        {onMenuClick && (
          <button
            type="button"
            className={Styles.menuButton}
            onClick={onMenuClick}
            aria-label="Toggle sidebar"
          >
            <img src={chatHamburgerIcon} alt="" className={Styles.menuButtonIcon} aria-hidden="true" />
          </button>
        )}
        <h4 className={`my-0 ${Styles.userName}`}>{name}</h4>
        <div className={`d-flex align-items-center ${Styles.headerActions}`}>
          {/* When the user is the host */}
          {(selected?.host?.pk === user?.pk) && (
            <Button
              label={selected.status !== 'VIDEO' ? "Start Video Chat" : "Join Video Chat"}
              cssClass={Styles.createRoomWidth}
              src={selected.status !== 'VIDEO' ? videoOutlineIcon : joinButtonIcon}
              alt="video chat"
              imageClass={Styles.chatHeaderImg}
              clickHandler={handleJoin}
              image
              showLoading={isVideoLoading}
              disabled={isVideoLoading}
            />)}

          {/* When the user is not the host and the video is started */}
          {(selected?.host?.pk !== user?.pk && (isJoined && selected.status === 'VIDEO' && selected.call_active)) && (
            <Button
              label="Join Video Chat"
              cssClass={Styles.createRoomWidth}
              src={joinButtonIcon}
              alt="join video chat"
              imageClass={Styles.chatHeaderImg}
              clickHandler={handleJoin}
              image
              showLoading={isVideoLoading}
              disabled={isVideoLoading}
            />)}

          <div className={Styles.desktopIcons}>
            {isJoined && (
              <div
                onClick={showChatInfo}
                onKeyPress={showChatInfo}
                role="button"
                tabIndex={0}
              >
                <img
                  src={chatInfoImage}
                  alt="chat info"
                  className={Styles.chatInfoImage}
                />
              </div>
            )}
            {selected?.host?.pk === user?.pk && (
              <>
                <div
                  onClick={handleDeleteRoom}
                  onKeyPress={handleDeleteRoom}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src={deleteIcon}
                    alt="delete icon"
                    className={Styles.deleteImage}
                  />
                </div>
                <div
                  className="position-relative"
                  onClick={() => setJoinRequest(true)}
                  onKeyPress={() => setJoinRequest(true)}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src={userRequestIcon}
                    alt="delete icon"
                    className={Styles.requestImage}
                  />
                  {requests.length > 0 && (
                    <div className={Styles.userRequestCounter}>
                      {requests.length}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>


        {joinRequest && (
        <CustomModal
          title="Join Requests"
          wrapperClass={ModalShell.wrapper}
          modalHeaderClass={ModalShell.header}
          modalTitleClass={ModalShell.title}
          cssClass={ModalShell.body}
          closeDialog={closeDialog}
          closeModal={closeDialog}
          close={false}
        >
          {joinRequests()}
        </CustomModal>
      )}

        {showDeleteConfirm && (
          <CustomModal
            title="Delete Room"
            wrapperClass={ModalShell.wrapper}
            modalHeaderClass={ModalShell.header}
            modalTitleClass={ModalShell.title}
            cssClass={ModalShell.body}
            closeDialog={closeDeleteConfirm}
            closeModal={closeDeleteConfirm}
            close={false}
          >
            {deleteConfirmModal()}
          </CustomModal>
        )}

        {toast && (
          <Toast
            message={toastValues.message}
            position="topRight"
            type={toastValues.type}
            handleCloseToast={setToast}
          />
        )}
      </div>
    </>
  );
};

const mapDispatchToProps = { invitePeople: invitePeopleRequest };

export default connect(null, mapDispatchToProps)(ChatHeader);